export enum PLAYER_TYPE {
  MP3_KBP = 'MP3_KBP',
  MP4 = 'MP4',
}

export interface DownloadSongMetadata {
  licenseToken: string;
  videoUrl: string;
  exprirationTimeStamp?: number;
}

interface CommonVideoMetadata {
  licenseToken: string;
  videoUrl: string;
  fairPlayCertificate: string;
  isPremium: boolean;
}

type Mp4VideoMetadata = {
  playerType: PLAYER_TYPE.MP4;
} & CommonVideoMetadata;

type VocalGuideMetadata =
  | {
      isVocalGuideAvailable: true;
      instrumentalWithVoicesFileUrl: string;
      instrumentalWithVoicesLicenseToken: string;
    }
  | {
      isVocalGuideAvailable: false;
    };

export type Mp3KbpVideoMetadata = {
  playerType: PLAYER_TYPE.MP3_KBP;
  lyricsJsonUrl: string;
} & CommonVideoMetadata &
  VocalGuideMetadata;

export type VideoMetadata = Mp4VideoMetadata | Mp3KbpVideoMetadata;
